function customSortArrays(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(customSortArrays).sort();
  } else if (obj !== null && typeof obj === "object") {
    const sortedObj: any = {};
    Object.keys(obj)
      .sort()
      .forEach((key) => {
        sortedObj[key] = customSortArrays(obj[key]);
      });
    return sortedObj;
  }
  return obj;
}

export default customSortArrays;
